import { Map, Map2 } from '../organisms/Map';

export default function ExplorePage() {
  return (
    <>
      <Map />
      <Map2 />
    </>
  )
}
